import { v4 as uuidv4 } from "uuid";

export function formatMoney(nominal) {
  if (nominal == null || isNaN(nominal)) return "";
  else if (nominal < 0) return `-${formatMoney(Math.abs(nominal))}`;

  const nominalStr = nominal.toString().split(".");
  const decimalValue = nominalStr[1] ? `,${nominalStr[1]}` : "";

  return `Rp${nominalStr[0].replace(
    /(\d)(?=(\d\d\d)+(?!\d))/g,
    "$1."
  )}${decimalValue}`;
}

export function getCurrentYear() {
  return new Date().getFullYear();
}

export function getMessageID() {
  return uuidv4().replaceAll("-", "");
}

/* 
* This function is used to sanitize HTML content to prevent XSS attacks. This will do the following:
* 1. Remove <script> tags
* 2. Remove event handler attributes (e.g., onclick, onmouseover)
*/
export function sanitizeHTML(html) {

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
  
    // Remove <script> tags
    const scriptTags = doc.querySelectorAll('script');
    scriptTags.forEach(tag => tag.remove());
  
    // Remove event handler attributes (e.g., onclick, onmouseover)
    const elements = doc.querySelectorAll('*');
    elements.forEach(element => {
      Array.from(element.attributes).forEach(attr => {
        if (attr.name.startsWith('on')) {
          element.removeAttribute(attr.name);
        }
      });
    });

    return doc.body.innerHTML;
}
